<template>
    <v-btn class="line-login-button" :disabled="disabled" :style="style['buttonStyle']" :ripple="false" depressed @click="lineLogin">
        <v-img :src="require('../assets/line_32.png')"></v-img>
        <div class="vertical-line">
            &nbsp;
        </div><p :style="style['pStyle']">
                {{ text }}
            </p>
    </v-btn>
  </template>
  
  <script>
  import {
    lineConfig
  } from '@/helpers/lineConfig';
  const settings = {
    normal: {
      buttonStyle: {
        margin: '0px',
        padding: '0px'
      },
      pStyle: {
        lineHeight: '10px',
        margin: '0px 30px',
      },
    },
  }
  export default {
    name: 'LineLoginButton',
    data () {
      return {
        text: 'Log in with LINE',
        clientId: '',
        clientSecret: '',
        callbackUri: ''
      }
    },
    computed: {
      style () {
        return settings['normal']
      },
    },
    created() {
        this.clientId = lineConfig.VUE_APP_LINE_CLIENT_ID
        this.clientSecret = lineConfig.VUE_APP_LINE_CLIENT_SECRET
        this.callbackUri = lineConfig.VUE_APP_LINE_CALLBACK_URL
    },
    methods: {
        lineLogin() {
            const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.callbackUri}&state=thaisook&scope=profile%20openid`;
            window.location.href = lineLoginUrl;
        }
    }
  }
  </script>
  

<style>
    button.line-login-button {
        display: inline-block;
        background-color: #06c755 !important;
        padding: 0px;
        word-break: keep-all;
        border-radius: 5px;
        transition-duration: 0s; 
        text-transform: none !important;
        /* padding: 0 30px 0 0px; */
    }
    button.line-login-button * {
        display: inline-block;
        vertical-align: middle;
        padding: 0px;
        border: 0px; 
    }
    button.line-login-button img {
        max-height: 100%; 
    }
    button.line-login-button div.vertical-line {
        width: 1px;
        height: 100%;
        margin: 0px !important;
        border-right: 1px solid #00b300 !important; 
    }
    button.line-login-button p {
        font-family: sans-serif;
        font-weight: bold;
        color: white;
        text-transform: none; 
    }
    button.line-login-button:hover {
        background-color: #06c755 !important; 
    }
    button.line-login-button:hover div.vertical-line {
        border-right-color: #00c900 !important; 
    }
    button.line-login-button:active {
        background-color: #00b300 !important; 
    }
    button.line-login-button:active div.vertical-line {
      border-right-color: #009800 !important; 
    }
    button.line-login-button:disabled {
        background-color: #b5b5b5 !important; 
    }
    button.line-login-button:disabled div.vertical-line {
        border-right-color: #c6c6c6 !important; 
    }
      
    button.line-login-button .v-btn__content {
        padding: 0px !important; 
    }
    button.line-login-button .v-btn__content:before {
        background-color: unset !important; 
    }

  </style>